import { render, staticRenderFns } from "./ProductsListFilters.vue?vue&type=template&id=3f3600dc"
import script from "./ProductsListFilters.vue?vue&type=script&lang=js"
export * from "./ProductsListFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductsListFilters.vue?vue&type=style&index=0&id=3f3600dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports